<script lang="ts">
import { VNode, CreateElement } from 'vue';
import { defineComponent } from '@vue/composition-api';
import { IResizeInfo } from '../../types';

export default defineComponent({
  name: 'BaseResizeObserver',
  emits: ['resize'],
  setup() {
    return {
      observer: null! as ResizeObserver,
    };
  },
  created(): void {
    const globalOnError = window.onerror;
    const ignoreLoopLimitExceeded = (...args: any) => {
      const message = args[0];
      if (message === 'ResizeObserver loop limit exceeded') {
        return true;
      } else {
        if (globalOnError) {
          return globalOnError(args);
        }
      }
    };
    if (!(window as any).isIgnoreLoopLimitExceededSet) {
      window.onerror = ignoreLoopLimitExceeded;
      (window as any).isIgnoreLoopLimitExceededSet = true;
    }
  },
  mounted(): void {
    this.observer = new ResizeObserver(() => {
      const el = this.$slots.default![0].elm as HTMLElement;
      const size: IResizeInfo = {
        height: el.offsetHeight,
        width: el.offsetWidth,
      };

      this.$emit('resize', size);
    });

    const target = this.$slots.default![0];
    this.observer.observe(target.elm as Element);
  },
  beforeDestroy(): void {
    this.observer.disconnect();
  },
  render(createElement: CreateElement): VNode {
    return this.$slots.default ? this.$slots.default[0] : createElement();
  },
});
</script>
